import * as ACTIONS from "@iso/redux/specificationsOptions/actionTypes";

const initialState = {
  specificationsOptions: {
    list: [],
    total: 0,
  },
};

function specificationsOptionsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_SPECIFICATIONS_OPTIONS_SUCCESS: {
      return {
        ...state,
        ...{ specificationsOptions: payload },
      };
    }

    default:
      return state;
  }
}

export default specificationsOptionsReducer;
